<template>
  <div class="context">
    <PageHeading
      :title="name"
    />
    <div
      class="circle-container"
      style="-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;" 
      unselectable="on"
      onselectstart="return false;" 
      onmousedown="return false;"
      :style="style"
    >
      <svg
        id="svgCanvas"
        class="circle-graph"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        :viewBox="`0 0 ${2 * radius} ${2 * radius}`"
      >
        <g
          id="graph-svg"
          :transform="`translate(${radius}, ${radius}) rotate(135)`"
        >
          <CircleCategory
            v-for="(category, index) in sorted_categories"
            :name="category.name"
            :color="category.color"
            :grade_color="category.grade_color"
            :goal_color="category.goal_color"
            :items="category.items"
            :index="index"
            :key="`category-${index}`"
            @click="open_single_category(category.id)"
          ></CircleCategory>
        </g>
      </svg>
    </div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <div class="dates-container">
            <p><span style="color: #404040">Avaliação:</span> {{ formatDate(rating_date) }}</p>
          </div>
        </v-col>
        <v-divider></v-divider>
        <v-col cols="12">
          <div class="dates-container">
            <p><span style="color: #404040">Meta:</span> {{ formatDate(goal_deadline) }}</p>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-btn
            block
            elevation="2"
            color="success"
            tile
            @click="rate"
          >Autoavaliação</v-btn>
        </v-col>
        <v-col cols="12">
          <v-btn
            block
            elevation="2"
            color="info"
            tile
            @click="setGoal"
          >Definir Metas</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CircleCategory from "@/components/CircleCategory.vue";
import PageHeading from "@/components/PageHeading.vue";

export default {
  name: "Context",
  components: {
    CircleCategory,
    PageHeading
  },
  data() {
    return {
      // context: {},
    }
  },
  mounted() {
    if (!this.loggedIn) console.error("Context.vue tryied to load without user logged in!");
  },
  computed: {
    group_id() { return this.$route.params.group_id; },
    context_id() { return this.$route.params.context_id; },
    name() { return this.context.name; },
    categories() { return this.context.categories; },
    rating_date() { return this.context.rating_date; },
    goal_deadline() { return this.context.goal_deadline; },
    sorted_categories() { return this.categories.slice().sort((a, b) => a.id > b.id ? -1 : (a.id < b.id ? 1 : 0)); },
    radius() { return this.$store.state.drawing_opts.radius; },
    context() { return this.$store.getters[`user/${this.group_id}/${this.context_id}/cached`]; },
    style() {
      return {
        height: `${2 * this.radius}px`
      };
    },
    ...mapGetters([
      "user_id",
      "loggedIn"
    ])
  },
  methods: {
    open_single_category(category_id) {
      this.$router.push(`category/${category_id}`);
    },
    formatDate(date) {
      const parts = date.split("-");
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },
    rate() {
      this.$router.push(`rating/grade`);
    },
    setGoal() {
      this.$router.push(`rating/goal`);
    }
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Rubik&display=swap");

.v-divider {
  border-width: thin !important;
}
.v-progress-linear {
  width: 300px !important;
}

.context {
  font-family: "Rubik", sans-serif;

  h2 {
    font-weight: normal;
    color: black;
  }
  .circle-container {
    box-sizing: content-box;
    padding-top: 2em;
    position: relative;

    .circle-graph {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
